import { defineComponent as _defineComponent } from 'vue'
import { BookIntervalCode } from "@/types";
import useCurrencyFormat from "@/use/useCurrencyFormat";
import { PropType } from "vue";


const __default__ = {
  name: "PaymentInfoWithSeats",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bookingDatesCount: {
    type: Number,
    default: 0,
  },
  oneTimeFare: {
    type: Number,
  },
  currentBookInterval: {
    type: String as PropType<BookIntervalCode>,
  },
  totalAmount: {
    type: Number,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const getFareCalculationStr = () => {
  const oneTimeFare = useCurrencyFormat(props.oneTimeFare);
  return `${oneTimeFare}원 x ${props.bookingDatesCount}일`;
};

const __returned__ = { props, getFareCalculationStr, get BookIntervalCode() { return BookIntervalCode }, get useCurrencyFormat() { return useCurrencyFormat } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})